<template>
  <vue-collapsible-panel-group
    accordion
    class="triumph-load-collapsible rounded-lg"
  >
    <vue-collapsible-panel :open="isOpen">
      <template #title>
        <div
          class="flex items-center gap-2 rounded-lg py-2 pl-3 pr-1 text-xs font-semibold text-dark-gray"
        >
          <img
            class=""
            src="@/assets/loads/triumph-logo.svg"
            alt="triumph logo"
          />
          <p class="text-xl font-medium text-white">Triumph Intelligence</p>
        </div>
      </template>
      <template #content>
        <div class="triumph-container rounded-b-lg p-[1px]">
          <div
            class="flex flex-col gap-2 rounded-b-lg bg-white px-4 py-3 text-left"
          >
            <p class="text-3xl font-semibold text-neutral-subtle-bold">
              {{ price }}
            </p>

            <div class="flex items-start gap-2">
              <img
                class="mt-1"
                src="@/assets/loads/chart-arrow.svg"
                alt="arrow"
              />
              <p class="font-normal text-neutral-subtlest">
                This load's rate is in the top 10% of similar loads on this
                lane.
              </p>
            </div>

            <div class="flex flex-col gap-2">
              <div class="flex items-center justify-between">
                <p class="text-neutral-subtle-bold">Confidence Level</p>
                <p class="text-neutral-subtle-bold">
                  {{ lanePrediction?.confidence_level }}
                </p>
              </div>

              <div class="relative h-2 rounded-lg bg-gray-200">
                <span
                  class="absolute left-0 h-2 w-4/5 rounded-lg bg-emerald-light"
                  :style="{ width: lanePrediction?.confidence_level + '%' }"
                ></span>
              </div>

              <div class="flex items-center">
                <p class="flex-1 text-xs text-neutral-subtle-bold">
                  Start: {{ formatPrice(lanePrediction?.start_buy_rate) }}
                </p>
                <p class="flex-1 text-xs text-neutral-subtle-bold">
                  Fuel: {{ formatPrice(lanePrediction?.fuel_rate) }}
                </p>
                <p class="flex-1 text-xs text-neutral-subtle-bold">
                  Milage: {{ Math.round(lanePrediction?.distance) }}
                </p>
              </div>

              <div class="mt-4 flex justify-between px-8">
                <div class="flex gap-6">
                  <div>
                    <p>ILF</p>

                    <div class="rounded-md bg-emerald-light">
                      <img
                        class="mt-1 p-1"
                        src="@/assets/loads/arrow-up-green.svg"
                        alt="arrow"
                      />
                    </div>
                  </div>

                  <div>
                    <p>OLF</p>

                    <div class="rounded-md bg-gray-100">
                      <img
                        class="mt-1 p-1"
                        src="@/assets/loads/arrow-right.svg"
                        alt="arrow"
                      />
                    </div>
                  </div>
                </div>

                <div class="flex gap-6">
                  <div>
                    <p>ILF</p>

                    <div class="rounded-md bg-danger-red">
                      <img
                        class="mt-1 p-1"
                        src="@/assets/loads/arrow-up-red.svg"
                        alt="arrow"
                      />
                    </div>
                  </div>

                  <div>
                    <p>OLF</p>

                    <div class="rounded-md bg-danger-red">
                      <img
                        class="mt-1 -scale-y-100 p-1"
                        src="@/assets/loads/arrow-up-red.svg"
                        alt="arrow"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <a
                href="/triumph-link"
                class="mt-4 text-center text-sm underline"
                style="color: #47379b"
                >Learn more about Triumph Intelligence</a
              >
            </div>
          </div>
        </div>
      </template>
    </vue-collapsible-panel>
  </vue-collapsible-panel-group>
</template>

<script>
import { ref, onBeforeMount, computed } from 'vue';
import { useStore } from 'vuex';
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel';
import { formatPrice } from '../../utils/currency.js';

export default {
  name: 'Triumph Collapsible Detail',
  components: {
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
  },
  props: {
    lanePrediction: Object,
  },
  setup() {
    const store = useStore();
    const isOpen = ref(false);

    const load = computed(() => store.state.loads.load_details);

    const price = computed(() => formatPrice(load?.value?.price));

    onBeforeMount(() => {
      setTimeout(() => {
        isOpen.value = true;
      }, 500);
    });

    return {
      price,
      isOpen,
      formatPrice,
    };
  },
};
</script>

<style>
.triumph-load-collapsible .vcp__header-title,
.triumph-load-collapsible .vcp.vcp--expanded .vcp__header,
.triumph-load-collapsible .vcp__header,
.triumph-load-collapsible .vcp__header:hover,
.triumph-load-collapsible .vcp__header-icon {
  /* background: white !important; */
  @apply rounded-lg;
}
.triumph-load-collapsible .vcp {
  @apply bg-transparent;
}
.triumph-load-collapsible .vcp__header {
  background: linear-gradient(90deg, #463b9d 0%, #5ccfd0 100%) !important;
}
.triumph-load-collapsible .vcp--expanded .vcp__header {
  @apply !rounded-b-none;
}

.triumph-load-collapsible .vcp__header-icon {
  @apply text-white;
}

.triumph-container {
  background: linear-gradient(90deg, #463b9d 0%, #5ccfd0 100%) !important;
}
</style>
